<template>
  <div
    class="photo-wrapper absolute bottom-0 right-0 z-0 -mt-20 aspect-[3/4] max-h-dvh w-full bg-cover md:aspect-auto md:h-full md:w-9/12 md:bg-contain md:bg-right-bottom lg:mt-0"
  ></div>
</template>

<script lang="ts" setup></script>
